/*
 * Concepts Messages
 *
 * This contains all the text for the Concepts component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.Concepts';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Monadic Block',
  },
  remove: {
    id: `${scope}.remove`,
    defaultMessage: 'Remove Concept',
  },
  removeAttribute: {
    id: `${scope}.remove`,
    defaultMessage: 'Remove Attribute',
  },
  removeAttributeValue: {
    id: `${scope}.removeAttributeValue`,
    defaultMessage: 'Remove attribute value',
  },
  addAttribute: {
    id: `${scope}.addAttribute`,
    defaultMessage: 'Add attribute',
  },
  addConcept: {
    id: `${scope}.addConcept`,
    defaultMessage: 'Add concept',
  },
  addFile: {
    id: `${scope}.addFile`,
    defaultMessage: 'Add content',
  },
  conceptPlaceholder: {
    id: `${scope}.conceptPlaceholder`,
    defaultMessage: 'Concept {index}',
  },
  attributePlaceholder: {
    id: `${scope}.attributePlaceholder`,
    defaultMessage: 'Attribute {index}',
  },
  modal: {
    uploadMessage: {
      id: `${scope}.uploadMessage`,
      defaultMessage:
        "Drag & Drop or <span class='color-blue-6'>browse</span> for files here",
    },
    addFileAttribute: {
      id: `${scope}.addFileAttribute`,
      defaultMessage: 'Add content for attribute {name}',
    },
    writeText: {
      id: `${scope}.text`,
      defaultMessage: 'Write text...',
    },
    cancel: {
      id: `${scope}.cancel`,
      defaultMessage: 'Close',
    },
    submit: {
      id: `${scope}.submit`,
      defaultMessage: 'Save',
    },
    labelText: {
      id: `${scope}.labelText`,
      defaultMessage: 'Text',
    },
    labelUpload: {
      id: `${scope}.labelUpload`,
      defaultMessage: 'Upload File',
    },
    conceptModalTitle: {
      id: `${scope}.conceptModalTitle`,
      defaultMessage: 'Add files to media block',
    },
    confirm: {
      removeAttributeTitle: {
        id: `${scope}.removeAttributeMessage`,
        defaultMessage: 'This will remove the attribute and its content.',
      },
      removeConceptTitle: {
        id: `${scope}.removeConceptMessage`,
        defaultMessage: 'This will remove the concept and its content.',
      },
      removeConceptAndLogicTitle: {
        id: `${scope}.removeConceptAndLogicTitle`,
        defaultMessage:
          'This will remove all logic rules containing this concept and its content.',
      },
      message: {
        id: `${scope}.message`,
        defaultMessage: 'Are you sure?',
      },
      cancel: {
        id: `${scope}.cancel`,
        defaultMessage: 'Cancel',
      },
      remove: {
        id: `${scope}.remove`,
        defaultMessage: 'Remove',
      },
    },
    errors: {
      textTooLong: {
        id: `${scope}.errors.textTooLong`,
        defaultMessage:
          "Yikes! That's a really long text. The limit is {maxLength} characters",
      },
    },
  },
});
